import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { AuthGuardService } from "src/app/services/auth-guard-service";
import { UsuarioService } from "src/app/services/http/usuario.service";
import { LoginService } from "src/app/services/login.service";
import { ModalMsgService } from "src/app/services/modal-msg.service";
import { UserConfigsUtils } from "src/app/utils/UserConfigsUtils";
import { ModalSenhaExpiradaComponent } from "./modal-senha-expirada/modal-senha-expirada.component";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  form: FormGroup;

  subscription = new Subscription();

  constructor(
    private authGuard: AuthGuardService,
    private modalMsg: ModalMsgService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private usuarioService: UsuarioService,
    private loginService: LoginService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      login: ["", Validators.required],
      senha: ["", Validators.required],
    });

    if (this.activeRoute.snapshot.data["logout"]) {
      this.loginService.logOut();
      this.router.navigate([""]);
    }

    this.subscription.add(
      this.loginService.getLogIn().subscribe((user) => {
        if (user) {
          this.router.navigate([this.authGuard.firstRoute]);
        }
      })
    );
  }

  async login(event = null) {
    if (event) event.target.blur();

    const fp = await this.getFingerPrint();

    this.usuarioService
      .efetuarLogin(
        this.form.controls.login.value,
        this.form.controls.senha.value,
        fp
      )
      .then(async (result) => {
        if (result["status"]) {
          UserConfigsUtils.manageUserConfigs(this.usuarioService, true);
          this.loginService.logIn(result.token);

        } else {
          UserConfigsUtils.removeUserConfigsStorage();
          this.modalMsg.openDialog("Acesso negado", result["msg"]);
        }
      })
      .catch((e) => {
        console.log(e)
        if (e.error.msg === 'O email ainda não está confirmado. Favor entrar em contato com o suporte.') {
         this.modalMsg.openDialog(
            "Acesso negado",
            "O email ainda não está confirmado. Favor entrar em contato com o suporte.",
            "danger"
          );
        } else if (e.status === 401) {
           this.openModal();
        }  else {
          UserConfigsUtils.removeUserConfigsStorage();
          this.modalMsg.openDialog(
            "Acesso negado",
            "Verifique se as informações de login e senha estão corretas. Caso contrário, entre em contato com nosso departamento de Suporte.",
            "danger"
          );
        }

      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  openModal() {
    const modalRef = this.modalService.open(ModalSenhaExpiradaComponent, { centered: true });
    modalRef.result.then(result => {
      if (result === "ok") {
        // Transmite o login pelo estado da navegação
        this.router.navigate(["/recuperar-senha"], {
          state: { login: this.form.controls.login.value },
        });
      }
    }).catch(error => console.error(error));
  }

  private async getFingerPrint(): Promise<string> {

    const userAgentNormalizado = navigator.userAgent.match(/\(([^)]+)\)/)[1].replace(/Chrome\/[\d.]+/, '').replace(/Safari\/[\d.]+/, '')

    const components = [
      userAgentNormalizado,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      navigator.platform,
      navigator.hardwareConcurrency
    ];

    const raw = components.join('|');
    const encoder = new TextEncoder();
    const data = encoder.encode(raw);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }
}
